<script lang="ts" setup>
    const props = defineProps<{
        src: string;
        aspectRatio?: '' | '16-9' | '4-3';
    }>();

    const srcDetails = useExternalVideoSrcDetails(props.src);

    const aspectRatioClass = computed(() => (props.aspectRatio ? `--aspect-ratio-${props.aspectRatio}` : ''));
</script>

<template>
    <template v-if="srcDetails">
        <ClientOnly>
            <CookieConsent :service-key="srcDetails.type">
                <div
                    class="external-video"
                    :class="aspectRatioClass"
                >
                    <YouTubePlayer
                        v-if="srcDetails.type === 'youtube'"
                        :src="srcDetails.src"
                        class="iframe"
                    />

                    <VimeoPlayer
                        v-if="srcDetails.type === 'vimeo'"
                        :src="srcDetails.src"
                        class="iframe"
                    />
                </div>
            </CookieConsent>
        </ClientOnly>
    </template>

    <template v-if="!srcDetails">
        <Note type="error">
            <p>
                <strong>{{ $t('general.error') }}</strong>
            </p>
            <p>{{ $t('errors.invalidExternalVideoUrl') }}</p>
        </Note>
    </template>
</template>

<style lang="scss" scoped>
    .external-video {
        width: 100%;
    }

    .--aspect-ratio-16-9 {
        aspect-ratio: 16/9;

        .iframe {
            height: 100%;
        }
    }

    .--aspect-ratio-4-3 {
        aspect-ratio: 4/3;

        .iframe {
            height: 100%;
        }
    }

    .iframe {
        width: 100%;
        height: auto;
        border: none;
    }
</style>
